import script from "./404.vue?vue&type=script&setup=true&lang=js"
export * from "./404.vue?vue&type=script&setup=true&lang=js"

import "./404.vue?vue&type=style&index=0&id=214a507e&lang=scss&scope=true"

const __exports__ = script;

export default __exports__